module.exports = __webpack_public_path__ + "static/media/no_img.15d00c80.png";